<agr-dialog
  [data]="data"
  (alt)="alt()"
  (cancel)="cancel()"
  (confirm)="confirm()"
  data-test="protected-fields-skipped-dialog"
>
  <div class="flex--row flex--gutter">
    <div class="flex__child--auto spacing--padding-all">
      {{
        'protectedFieldsSkippedDialog.description'
          | translate
            : {
                cropFieldCount: data.groups.length.toString(),
                skippedFieldCount: totalSkippedFields.toString(),
              }
      }}
    </div>
  </div>

  <mat-action-list class="action-list">
    @for (group of data.groups; track trackByCropFieldId($index, group)) {
      <div
        class="cropfield-group"
        [attr.data-test]="'protected-fields-skipped-group--' + group.cropFieldId"
      >
        <div class="cropfield-name">{{ group.cropFieldName }}</div>
        <mat-chip-set>
          @for (field of group.skippedFields; track trackBySkippedField($index, field)) {
            <mat-chip disableRipple>{{ getFieldTranslationKey(field) | translate }}</mat-chip>
          }
        </mat-chip-set>
      </div>
    }
  </mat-action-list>
</agr-dialog>
